import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import theme from '../../theme';
import { appStart } from '../../features/app/actions';
import Notification from '../Notification';
import Alert from '../Alert';
import ErrorBoundary from '../../utils/ErrorBoundry';
import PromptProvider from '../Prompt/PromptProvider';
import Routes from './Routes';
import useLeavePageConfirmation from '../../features/app/hooks/useLeavePageConfirmation';
import { getIsPPSIEnabledUser } from '../../features/loginSystem/selectors';
import UserAccessNotEnabledMessage from '../common/UserAccessNotEnabledMessage';
import { logout } from '../../features/loginSystem/actions';

const App = () => {
  const dispatch = useDispatch();
  const isPPSIEnabledUser = useSelector(getIsPPSIEnabledUser);

  const [changePageConfirmation] = useLeavePageConfirmation();

  useEffect(() => {
    dispatch(appStart());
  }, [dispatch]);

  useEffect(() => {
    if (!isPPSIEnabledUser) {
      dispatch(logout(!isPPSIEnabledUser));
    }
  }, [dispatch]);

  return (
    <Router getUserConfirmation={changePageConfirmation}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <MuiThemeProvider theme={theme}>
          <ErrorBoundary>
            <CssBaseline />
            <PromptProvider>
              {isPPSIEnabledUser && <Routes />}
              {!isPPSIEnabledUser && <UserAccessNotEnabledMessage />}
            </PromptProvider>
            <Notification />
            <Alert />
          </ErrorBoundary>
        </MuiThemeProvider>
      </MuiPickersUtilsProvider>
    </Router>
  );
};

export default App;
